import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Combobox, factory, Input, InputBase, Text, useCombobox, useProps, useUncontrolled } from "@coveord/plasma-mantine";
import { InfiniteScroll } from "../InfiniteScroll.js";
import { groupOptions } from "../../../utilities/group-options.js";
var DefaultInfiniteScrollSelectItem = function(param) {
    var selected = param.selected, data = param.data;
    return /*#__PURE__*/ _jsx(Text, {
        fw: selected ? 500 : 400,
        children: data.label
    });
};
var defaultProps = {
    searchPlaceholder: "Search",
    nothingFoundMessage: "No matching items",
    placeholder: "No items",
    height: 200,
    limit: Infinity,
    itemComponent: DefaultInfiniteScrollSelectItem
};
export var InfiniteScrollSelect = factory(function(_props, ref) {
    var ref1;
    var props = useProps("InfiniteScrollSelect", defaultProps, _props);
    var data = props.data, onChange = props.onChange, _defaultValue = props.defaultValue, defaultValue = _defaultValue === void 0 ? null : _defaultValue, value = props.value, ItemComponent = props.itemComponent, searchPlaceholder = props.searchPlaceholder, query = props.query, _searchable = props.searchable, searchable = _searchable === void 0 ? data.length > 7 : _searchable, onSearch = props.onSearch, _filter = props.filter, filter = _filter === void 0 ? defaultFilter : _filter, nothingFoundMessage = props.nothingFoundMessage, placeholder = props.placeholder, height = props.height, radius = props.radius, __staticSelector = props.__staticSelector, classNames = props.classNames, styles = props.styles, limit = props.limit, vars = props.vars, unstyled = props.unstyled, description = props.description, label = props.label, others = _object_without_properties(props, [
        "data",
        "onChange",
        "defaultValue",
        "value",
        "itemComponent",
        "searchPlaceholder",
        "query",
        "searchable",
        "onSearch",
        "filter",
        "nothingFoundMessage",
        "placeholder",
        "height",
        "radius",
        "__staticSelector",
        "classNames",
        "styles",
        "limit",
        "vars",
        "unstyled",
        "description",
        "label"
    ]);
    var combobox = useCombobox({
        onDropdownClose: function() {
            combobox.resetSelectedOption();
            combobox.focusTarget();
            handleSearch("");
        },
        onDropdownOpen: function() {
            combobox.focusSearchInput();
        }
    });
    var ref2 = _sliced_to_array(useUncontrolled({
        value: query,
        defaultValue: "",
        finalValue: "",
        onChange: onSearch
    }), 2), search = ref2[0], handleSearch = ref2[1];
    var ref3 = _sliced_to_array(useUncontrolled({
        value: value,
        defaultValue: defaultValue,
        finalValue: null,
        onChange: onChange
    }), 2), _selection = ref3[0], handleSelection = ref3[1];
    var filteredData = data.filter(function(item) {
        return filter(search, item);
    }).slice(0, limit);
    var selectedLabel = (ref1 = data.find(function(item) {
        return item.value === _selection;
    })) === null || ref1 === void 0 ? void 0 : ref1.label;
    var sortedData = groupOptions({
        data: filteredData
    }).map(function(item) {
        return /*#__PURE__*/ _jsx(Combobox.Option, {
            active: _selection === item.value,
            "aria-selected": _selection === item.value,
            value: item.value,
            onMouseEnter: function() {
                return combobox.resetSelectedOption();
            },
            children: /*#__PURE__*/ _jsx(ItemComponent, {
                data: item,
                selected: _selection === item.value
            })
        }, item.value);
    });
    var handleValueSelect = function(val) {
        handleSelection(val);
        combobox.closeDropdown();
    };
    return /*#__PURE__*/ _jsxs(Combobox, _object_spread_props(_object_spread({
        store: combobox,
        onOptionSubmit: handleValueSelect
    }, others), {
        children: [
            /*#__PURE__*/ _jsx(Combobox.Target, {
                children: /*#__PURE__*/ _jsx(InputBase, {
                    component: "button",
                    label: label,
                    description: description,
                    type: "button",
                    pointer: true,
                    rightSection: /*#__PURE__*/ _jsx(Combobox.Chevron, {}),
                    onClick: function() {
                        return combobox.toggleDropdown();
                    },
                    rightSectionPointerEvents: "none",
                    children: selectedLabel || /*#__PURE__*/ _jsx(Input.Placeholder, {
                        children: placeholder
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Combobox.Dropdown, {
                children: [
                    /*#__PURE__*/ _jsx(Combobox.Search, {
                        value: search,
                        onChange: function(event) {
                            return handleSearch(event.currentTarget.value);
                        },
                        placeholder: searchPlaceholder
                    }),
                    /*#__PURE__*/ _jsx(Combobox.Options, {
                        children: /*#__PURE__*/ _jsx(InfiniteScroll, {
                            style: {
                                height: searchable ? height : "auto",
                                overflow: "auto",
                                position: "relative"
                            },
                            children: sortedData.length > 0 ? sortedData : /*#__PURE__*/ _jsx(Combobox.Empty, {
                                children: /*#__PURE__*/ _jsx(Text, {
                                    c: "dimmed",
                                    unstyled: unstyled,
                                    size: "sm",
                                    ta: "center",
                                    my: "sm",
                                    children: !query && placeholder ? placeholder : nothingFoundMessage
                                })
                            })
                        })
                    })
                ]
            })
        ]
    }));
});
InfiniteScrollSelect.displayName = "InfiniteScrollSelect";
var defaultFilter = function(query, item) {
    return item.label.toLowerCase().trim().includes(query.toLowerCase().trim()) || item.value.toLowerCase().trim().includes(query.toLowerCase().trim());
};

//# sourceMappingURL=InfiniteScrollSelect.js.map